import { HTTPPollingService } from '@timing71/common';
import { Message } from '@timing71/common/messages';

import { getManifest, getState } from './translate.js';

const MOTOGP_FREE_TIMING_URL = 'https://api.pulselive.motogp.com/motogp/v1/timing-gateway/livetiming-lite';
const POLL_RATE = 5000;

const cacheBustedURL = () => `${MOTOGP_FREE_TIMING_URL}?${Date.now()}`;

export class MotoGP extends HTTPPollingService {
  constructor(...args) {
    super(
      cacheBustedURL,
      POLL_RATE,
      ...args
    );
    this._prevSessionIdent = null;
  }

  start(...args) {
    super.start(...args);
    this.onStateChange({
      extraMessages: [
        new Message(
          'System',
          'MotoGP free timing is very slow to update. Some calculated durations will be inaccurate.',
          'system'
        ).toCTDFormat()
      ]
    })
  }

  async handleResponse(response) {
    if (response) {
      const data = JSON.parse(response);

      const sessionIdent = `${data.head.championship_id},${data.head.session_id}`;

      if (sessionIdent !== this._prevSessionIdent) {
        this._prevSessionIdent = sessionIdent;
        this.onSessionChange();
      }

      const manifest = getManifest(data);
      this.onManifestChange(manifest);

      const state = getState(data);
      this.onStateChange(state);
    }
    else {
      this.emitWarning("Null response", "No response from timing source");
    }
  }
}

MotoGP.regex = /\.motogp\.com/
